import React from 'react';
import { FormattedMessage, FormattedDate } from 'react-intl';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import messages from './messages';
import './styles.css';

export const SelectRangeTrigger = () => (
  <Button
    data-cy="repvisits-calendar-export-button"
    styleName="export"
    title="Export"
  >
    <FormattedMessage {...messages.exportEvents} />
  </Button>
);

export const SelectFirstDayTrigger = (firstDay) => (
  <Button
    styleName="toDate"
    title="From"
    data-cy="repvisits-calendar-export-from-date"
  >
    <b>
      <FormattedDate
        value={firstDay}
        month="2-digit"
        day="numeric"
        year="numeric"
      />
    </b>
    <Icon
      styleName="calendar"
      data-cy="repvisits-calendar-export-from-date-open-calendar"
      name="calendar outline"
      link
      color="grey"
    />
  </Button>
);

export const SelectLastDayTrigger = (lastDay) => (
  <Button
    styleName="fromDate"
    title="To"
    data-cy="repvisits-calendar-export-to-date"
  >
    <b>
      <FormattedDate
        value={lastDay}
        month="2-digit"
        day="numeric"
        year="numeric"
      />
    </b>
    <Icon
      styleName="calendar"
      data-cy="repvisits-calendar-export-to-date-open-calendar"
      name="calendar outline"
      link
      color="grey"
    />
  </Button>
);
